/**
 * Who answers the channel, as the widget reads it (86bcj1kba). The bootstrap serves `responder`
 * (`agent | team | operators`) and, when an agent is bound, `primaryAssistantId`. An "Operators only"
 * channel has no agent: it is a chat with operators, never a voice call, and there is no agent to read.
 */

/** The id the console's "Operators only" option carries; never a real agent id. */
const OPERATORS_ID = "operators";

export const isOperatorsOnly = (widget) => widget?.responder === "operators";

/** The modes the widget offers: an operators-only channel is chat; otherwise the agent's own modes. */
export const widgetModes = (widget, assistant) => {
	if (isOperatorsOnly(widget)) return { chat: true, voice: false };
	const modes = assistant?.config?.general?.modes;
	return {
		chat: Array.isArray(modes) && modes.includes("chat"),
		voice: Array.isArray(modes) && modes.includes("voice") && !!assistant?.config?.voiceConfig?.voiceId,
	};
};

/**
 * The agent to read: the channel's own (`primaryAssistantId`) over the embed snippet's `assistantId`, which
 * can be stale after the responder changed. Null for an operators-only channel, or when nothing names one.
 */
export const assistantIdToRead = (widget, embedAssistantId) => {
	if (isOperatorsOnly(widget)) return null;
	const id = widget?.primaryAssistantId || embedAssistantId;
	return id && id !== OPERATORS_ID ? id : null;
};
